import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GuideCardComponent } from '@shared/components/guide-card/guide-card.component';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { TranslatePipe } from '@ngx-translate/core';
import {
  CreateMeteringPointCommand,
  MeteringPointSubType,
  MeterReadingType,
  ProductCharacteristicUnitType,
  UpdateMeteringPointCommand
} from '@app/api/dmc';
import { FormGroupType } from '@app/core/utils/formgroup-type';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { InputFixedDigitsDirective } from '@shared/components/input/fixeddigits/input-fixeddigits.directive';

@Component({
  selector: 'app-meteringpoint-form-meter',
  imports: [
    ReactiveFormsModule,
    GuideCardComponent,
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    SelectDirective,
    TranslatePipe,
    InputFixedDigitsDirective
  ],
  templateUrl: './meteringpoint-form-meter.component.html',
  styleUrl: './meteringpoint-form-meter.component.css'
})
export class MeteringpointFormMeterComponent {
  @Input() public form!: FormGroupType<CreateMeteringPointCommand | UpdateMeteringPointCommand>;

  @Input() public fullWidth: boolean = true;

  protected readonly MeteringPointSubType = MeteringPointSubType;

  /** Populated Lists **/
  public unitTypeList: KeyValue[] = enumToKeyValue(ProductCharacteristicUnitType, { omitKeys: ['NotSpecified'], prefixValue: 'enum.meteringpoint.unittype.'});
  public meterReadingTypeList: KeyValue[] = enumToKeyValue(MeterReadingType, { omitKeys: ['NotSpecified'], prefixValue: 'enum.meteringpoint.meterreadingtype.'});
}
